document.addEventListener("DOMContentLoaded", function() {
  if (window.Shopify && window.Shopify.designMode) return;

  // 配置 by Mary
  const config = {
    country: 'CA',
    redirectUrl: 'https://antevorta.ca',
    domain: 'antevorta.ca',
    message: 'Thank you for visiting Antevorta. We have detected that you are visiting from Canada and we will redirect you to our Canadian site so your orders could be shipped smoothly.',
    redirectBtn: 'Redirect Now',
    countdownTime: 5
  };

  // 已经在CA站 或 爬虫 -> 不触发
  if (
    window.location.hostname.includes(config.domain) ||
    /bot|crawler|spider|crawling/i.test(navigator.userAgent)
  ) return;

  // 获取IP国家
  fetch('https://ipapi.co/json/')
    .then(res => res.json())
    .then(data => {
      if (data.country_code === config.country) {
        createPopup();
      }
    })
    .catch(err => console.error('Location error:', err));

  // 创建弹窗
  function createPopup() {

    const html = `
      <div id="geo-popup" style="
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background:rgba(0,0,0,0.5);
        display:flex;
        align-items:center;
        justify-content:center;
        z-index:9999;
        padding:20px;
      ">
        <div style="
          background:white;
          padding:30px;
          max-width:500px;
          width:100%;
          position:relative;
          box-shadow:0 4px 20px rgba(0,0,0,0.15);
        ">
          <button id="geo-close" style="
            position:absolute;
            top:10px;
            right:12px;
            background:none;
            border:none;
            font-size:22px;
            cursor:pointer;
            color:#666;
          ">&times;</button>

          <p style="margin-bottom:25px;text-align:center;line-height:1.6;">
            ${config.message}
          </p>

          <p style="text-align:center;margin-bottom:20px;">
            Redirecting in <span id="countdown">${config.countdownTime}</span> seconds...
          </p>

          <div style="display:flex;justify-content:center;">
            <button id="geo-redirect" style="
              padding:12px 24px;
              background:#000;
              color:white;
              border:none;
              cursor:pointer;
              font-weight:500;
            ">
              ${config.redirectBtn}
            </button>
          </div>
        </div>
      </div>
    `;

    const container = document.createElement('div');
    container.innerHTML = html;
    document.body.appendChild(container);

    const redirectBtn = document.getElementById('geo-redirect');
    const closeBtn = document.getElementById('geo-close');
    const countdownElement = document.getElementById('countdown');

    redirectBtn.addEventListener('click', redirect);
    closeBtn.addEventListener('click', function() {
      clearInterval(countdownInterval);
      document.getElementById('geo-popup').remove();
    });

    let secondsLeft = config.countdownTime;

    const countdownInterval = setInterval(() => {
      secondsLeft--;
      countdownElement.textContent = secondsLeft;

      if (secondsLeft <= 0) {
        clearInterval(countdownInterval);
        redirect();
      }
    }, 1000);
  }

  function redirect() {
    window.location.href = config.redirectUrl;
  }

});